/*
  The cart's "Items reserved for MM:SS" countdown.

  Markup: the [data-pl-cart-timer] paragraph in sections/main-cart-items.liquid,
  beside the <h1> and therefore outside .js-contents — cart.js replaces that
  element's innerHTML on every quantity change, and a countdown that restarted
  each time someone tapped + would be both wrong and obviously fake.

  What is stored is a DEADLINE, not a remaining count. Two reasons: a background
  tab has its timers throttled to roughly once a minute, so a decrementing
  counter would drift and need correcting; and the deadline survives a page
  navigation, which a counter in memory cannot. Reading the clock against an
  absolute timestamp is always correct with no catch-up logic.

  sessionStorage rather than localStorage, deliberately: per tab, cleared when
  the tab closes. Browsing to a product and back continues the same countdown
  (the point of persisting it at all), while a genuinely new visit starts fresh.
  localStorage would show someone returning next week a long-dead timer.

  Expiry: the row disappears. "00:00 reserved" reads as a broken widget, and
  silently rolling back to 05:00 is a claim the shopper can catch by watching it
  for six minutes. Disappearing is the only behaviour that is never wrong.

  Styles: pujalane-card-style.css section 29.
*/
(function () {
  var RESERVE_MINUTES = 5;
  var STORE_KEY = 'pl-cart-reserve-deadline';

  // Set only when sessionStorage is unavailable — Safari private mode and
  // blocked-cookie contexts throw on access, not just on write.
  var memoryDeadline = null;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function readStored() {
    try {
      return parseInt(window.sessionStorage.getItem(STORE_KEY), 10);
    } catch (e) {
      return memoryDeadline;
    }
  }

  function writeStored(ms) {
    memoryDeadline = ms;
    try {
      window.sessionStorage.setItem(STORE_KEY, String(ms));
    } catch (e) {
      /* memoryDeadline above is the fallback */
    }
  }

  function deadline() {
    var stored = readStored();
    var max = Date.now() + RESERVE_MINUTES * 60000;

    // A stored value further out than the full window means the clock moved
    // under us (timezone change, manual adjustment) or someone edited storage.
    // Either way it is not a deadline we set, so start over.
    if (!stored || isNaN(stored) || stored > max) {
      writeStored(max);
      return max;
    }
    return stored;
  }

  var ticker = null;

  function paint() {
    // Re-queried every tick rather than cached: the theme editor replaces whole
    // sections, and a node captured from a replaced one stays blank for good.
    // Same reasoning as pujalane-delivery-eta.js.
    var rows = document.querySelectorAll('[data-pl-cart-timer]');
    if (!rows.length) return;

    var left = deadline() - Date.now();

    if (left <= 0) {
      for (var i = 0; i < rows.length; i++) {
        if (!rows[i].hidden) rows[i].hidden = true;
      }
      stop();
      return;
    }

    var text = pad(Math.floor(left / 60000)) + ':' + pad(Math.floor((left % 60000) / 1000));
    var clocks = document.querySelectorAll('[data-pl-cart-timer-clock]');
    for (var j = 0; j < clocks.length; j++) {
      // Only touch what actually changed — this runs once a second, and
      // rewriting identical text would churn layout for nothing.
      if (clocks[j].textContent !== text) clocks[j].textContent = text;
    }

    for (var k = 0; k < rows.length; k++) {
      if (rows[k].hidden) rows[k].hidden = false;
    }
  }

  function start() {
    paint();
    if (ticker === null) ticker = setInterval(paint, 1000);
  }

  function stop() {
    if (ticker !== null) {
      clearInterval(ticker);
      ticker = null;
    }
  }

  // A backgrounded tab throttles the interval, so the clock is stale on return.
  // Repainting against the deadline resyncs it exactly.
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) return;
    paint();
  });

  window.addEventListener('pageshow', start);
  window.addEventListener('pagehide', stop);

  start();
})();
